module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAAGXcA1uAAAAAXNSR0IArs4c6QAAAJ1JREFUSA3tU0EOgCAMG77A+Enf4tmTnzT+QAeRhEGHLjHqAS9AW7duy2hfaaHz6+LFn+JBBlkqjQFlsIjy6ZA68BqhhnqQUF0Jwg00JqXAq2oKqhn84Q++6Imt9ZrnAvez0+ZXiBn4YdHNEhpUjol9yEn0NrcVZrizeSg7wsyOUJAa1hLUuhO41qLvWwQX7dKWQfDKkGc2tBlMmaQHtLcmFfWLn10AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb.png
// module id = XqWh
// module chunks = 0